// @ts-check

import { combineReducers } from 'redux';
import bowVendorsReducer, {
	initialState as bowVendorsReducerInitialState,
} from './bow_vendors';
import paiverVendorsReducer, {
	initialState as paiverVendorsReducerInitialState,
} from './paiver_vendors';
import pvRecAnonVendorsReducer, {
	initialState as pvRecAnonVendorsReducerInitialState,
} from './pvrec_anon_vendors';
import pvRecCrossCatVendorsReducer, {
	initialState as pvRecCrossCatVendorsReducerInitialState,
} from './pvrec_cross_cat_vendors';
import similarVendorsBasedOnActivityReducer, {
	initialState as similarVendorsBasedOnActivityReducerInitialState,
} from './similar_vendor_based_on_activity';
import similarVendorsReducer, {
	initialState as similarVendorsReducerInitialState,
} from './similar_vendors';

/** @type {Redux.Widget} @internal */
export const initialState = {
	bowVendorsReducer: bowVendorsReducerInitialState,
	paiverVendorsReducer: paiverVendorsReducerInitialState,
	pvRecAnonVendorsReducer: pvRecAnonVendorsReducerInitialState,
	pvRecCrossCatVendorsReducer: pvRecCrossCatVendorsReducerInitialState,
	similarVendorsReducer: similarVendorsReducerInitialState,
	similarVendorsBasedOnActivityReducer:
		similarVendorsBasedOnActivityReducerInitialState,
};

const combinedReducer = combineReducers({
	bowVendorsReducer,
	paiverVendorsReducer,
	pvRecAnonVendorsReducer,
	pvRecCrossCatVendorsReducer,
	similarVendorsReducer,
	similarVendorsBasedOnActivityReducer,
});

export default combinedReducer;
